// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__32QMT","resendInfoText":"OnGoingPaymentBox_resendInfoText__2N0pT"};